module.exports = __webpack_public_path__ + "images/comodo-secure-seal.png";


//////////////////
// WEBPACK FOOTER
// ./images/comodo-secure-seal.png
// module id = 1108
// module chunks = 1